import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  WaterQualityIndexResponse,
  WaterQualityIndexState,
} from './waterQualityIndex.types'
import {
  fetchWaterQualityIndexAsync,
  fetchWaterQualityIndexAsyncBuilder,
  fireWqiReportCompletedAsync,
} from './asyncRequests'

const initialState: WaterQualityIndexState = {
  data: null,
  loading: false,
  success: false,
  error: null,
}

const waterQualityIndexSlice = createSlice({
  name: 'waterQualityIndex',
  initialState,
  reducers: {
    setWaterQualityIndex: (
      state,
      action: PayloadAction<WaterQualityIndexResponse>
    ) => {
      state.data = action.payload
      state.success = true
      state.error = null
    },
    clearWaterQualityIndex: (state) => {
      state.data = null
      state.success = false
      state.error = null
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    fetchWaterQualityIndexAsyncBuilder(builder)
  },
})

export const WaterQualityIndexActions = {
  ...waterQualityIndexSlice.actions,
  fetchWaterQualityIndexAsync,
  fireWqiReportCompletedAsync,
}

export const WaterQualityIndexReducer = waterQualityIndexSlice.reducer
